/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-border-color',
  templateUrl: './theme-option-tooltips-border-color.component.html',
  styleUrls: ['./theme-option-tooltips-border-color.component.css']
})
export class ThemeOptionTooltipsBorderColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_borderColor';
  opacity: number;
  borderColor: string;

  constructor() {}

  ngOnInit() {
    this.borderColor = this.themeOptions.options().tooltips.borderColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.options().tooltips.borderColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.borderColor = value;
    this.themeOptions.setOption('tooltips_borderColor', value + Math.round(this.opacity * 255 / 100).toString(16));
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) this.themeOptions.setOption('tooltips_borderColor', this.borderColor + Math.round(value * 255 / 100).toString(16));
    else this.themeOptions.setOption('tooltips_borderColor', this.borderColor + '00');
  }

}
